module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.refunds), function(refund) {
    return _c('refund-single-row', {
      key: refund.id,
      staticClass: "mb-1",
      attrs: {
        "refund": refund
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30514d48"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/TabRefunds/refundRows.vue
// module id = 1674
// module chunks = 0